import Dropdown from "@/components/Dropdown"
import { formatTextWithItalics } from "@/utils/TextFormatter"
import { useTranslation } from 'react-i18next';

interface FAQProps {
  faqs: {
    question: string;
    answer: string;
  }[];
  dropdownStyles?: {
    bgColorOpen?: string;
    borderColorOpen?: string;
    textColorOpen?: string;
    iconColorOpen?: string;
  }
}

const ServiceFAQ = ({ faqs, dropdownStyles }: FAQProps) => {
  const { t } = useTranslation(); 
  return (
    <section className="flex flex-col p-8 md:flex-row md:px-[90px] py-36 pt-16">
      <div className="basis-1/4 md:p-6">
        <h1 className="text-4xl font-bold text-center mb-4 md:text-left">{t('faq.title')}</h1>
      </div>
      <div className="flex-col flex basis-3/4 md:p-6 gap-4 max-w-3xl">
        {faqs.map((faq, index) => (
          <Dropdown 
            key={index}
            title={formatTextWithItalics(faq.question)}
            content={formatTextWithItalics(faq.answer)}
            bgColorOpen={dropdownStyles?.bgColorOpen}
            borderColorOpen={dropdownStyles?.borderColorOpen}
            textColorOpen={dropdownStyles?.textColorOpen}
            iconColorOpen={dropdownStyles?.iconColorOpen}
          />
        ))}
      </div>
    </section>
  )
}

export default ServiceFAQ 